import {
  Tax,
} from '@dapi/sdk';

export const taxTemplate: Tax = {
  value: 500,
  currencyCode: 'EUR',
  code: 'FR',
  currency: {
    name: 'EURO',
    decimalPlaces: 2
  }
};
